import { SWITCH_DARK, SWITCH_LIGHT } from './actionTypes'

export const Switch2Dark = () => {
    return {
        type:SWITCH_DARK
    }
}

export const Switch2Light = () => {
    return {
        type:SWITCH_LIGHT
    }
}